import SuccessModal from './SuccessModal';

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/Modals/SuccessModal/index.ts